module.exports = __webpack_public_path__ + "static/media/51.28299e72.png";